import type { ExecutionContext } from 'styled-components'
import { css } from 'styled-components'
import { themeGet } from '@styled-system/theme-get'

type CustomColor002Props = {
  body?: boolean
  important?: boolean
  inverse?: boolean
  success?: boolean
}

const importantCss = ({
  important,
}: ExecutionContext & { important?: boolean }) =>
  important &&
  css`
    color: ${themeGet('colors.text.important')};
  `

const inverseCss = ({ inverse }: ExecutionContext & { inverse?: boolean }) =>
  inverse &&
  css`
    color: ${themeGet('colors.text.inverse')};
  `

const successCss = ({ success }: ExecutionContext & { success?: boolean }) =>
  success &&
  css`
    color: ${themeGet('colors.text.success')};
  `

const bodyCss = ({ body }: ExecutionContext & { body?: boolean }) =>
  body &&
  css`
    color: ${themeGet('colors.text.body')};
  `

export type { CustomColor002Props }
export { bodyCss, importantCss, inverseCss, successCss }
